/* tslint:disable */

declare var Object: any;
export interface TtadattendanceInterface {
  "attendId": string;
  "empId": string;
  "shiftdailyCode": string;
  "companyId": number;
  "shiftstarttime"?: Date;
  "shiftendtime"?: Date;
  "attendCode"?: string;
  "starttime"?: Date;
  "endtime"?: Date;
  "actualIn"?: number;
  "actualOut"?: number;
  "daytype": string;
  "ipStarttime"?: string;
  "ipEndtime"?: string;
  "remark"?: string;
  "defaultShift": string;
  "totalOt"?: number;
  "totalOtindex"?: number;
  "overtimeCode": string;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "flexibleshift"?: string;
  "autoOvt"?: number;
  "actualworkmnt"?: number;
  "photoStart"?: string;
  "photoEnd"?: string;
  "geolocStart"?: string;
  "geolocEnd"?: string;
  teomemppersonals?: any;
  ttadattstatusdetails?: any[];
  ttamshiftdailies?: any;
  ttadshiftbreaks?: any[];
  ttamattstatuses?: any;
}

export class Ttadattendance implements TtadattendanceInterface {
  "attendId": string;
  "empId": string;
  "shiftdailyCode": string;
  "companyId": number;
  "shiftstarttime": Date;
  "shiftendtime": Date;
  "attendCode": string;
  "starttime": Date;
  "endtime": Date;
  "actualIn": number;
  "actualOut": number;
  "daytype": string;
  "ipStarttime": string;
  "ipEndtime": string;
  "remark": string;
  "defaultShift": string;
  "totalOt": number;
  "totalOtindex": number;
  "overtimeCode": string;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "flexibleshift": string;
  "autoOvt": number;
  "actualworkmnt": number;
  "photoStart": string;
  "photoEnd": string;
  "geolocStart": string;
  "geolocEnd": string;
  teomemppersonals: any;
  ttadattstatusdetails: any[];
  ttamshiftdailies: any;
  ttadshiftbreaks: any[];
  ttamattstatuses: any;
  constructor(data?: TtadattendanceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttadattendance`.
   */
  public static getModelName() {
    return "Ttadattendance";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttadattendance for dynamic purposes.
  **/
  public static factory(data: TtadattendanceInterface): Ttadattendance{
    return new Ttadattendance(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttadattendance',
      plural: 'Ttadattendances',
      path: 'Ttadattendances',
      properties: {
        "attendId": {
          name: 'attendId',
          type: 'string'
        },
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "shiftdailyCode": {
          name: 'shiftdailyCode',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "shiftstarttime": {
          name: 'shiftstarttime',
          type: 'Date'
        },
        "shiftendtime": {
          name: 'shiftendtime',
          type: 'Date'
        },
        "attendCode": {
          name: 'attendCode',
          type: 'string'
        },
        "starttime": {
          name: 'starttime',
          type: 'Date'
        },
        "endtime": {
          name: 'endtime',
          type: 'Date'
        },
        "actualIn": {
          name: 'actualIn',
          type: 'number'
        },
        "actualOut": {
          name: 'actualOut',
          type: 'number'
        },
        "daytype": {
          name: 'daytype',
          type: 'string'
        },
        "ipStarttime": {
          name: 'ipStarttime',
          type: 'string'
        },
        "ipEndtime": {
          name: 'ipEndtime',
          type: 'string'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
        "defaultShift": {
          name: 'defaultShift',
          type: 'string'
        },
        "totalOt": {
          name: 'totalOt',
          type: 'number'
        },
        "totalOtindex": {
          name: 'totalOtindex',
          type: 'number'
        },
        "overtimeCode": {
          name: 'overtimeCode',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "flexibleshift": {
          name: 'flexibleshift',
          type: 'string'
        },
        "autoOvt": {
          name: 'autoOvt',
          type: 'number'
        },
        "actualworkmnt": {
          name: 'actualworkmnt',
          type: 'number'
        },
        "photoStart": {
          name: 'photoStart',
          type: 'string'
        },
        "photoEnd": {
          name: 'photoEnd',
          type: 'string'
        },
        "geolocStart": {
          name: 'geolocStart',
          type: 'string'
        },
        "geolocEnd": {
          name: 'geolocEnd',
          type: 'string'
        },
      },
      relations: {
        teomemppersonals: {
          name: 'teomemppersonals',
          type: 'any',
          model: ''
        },
        ttadattstatusdetails: {
          name: 'ttadattstatusdetails',
          type: 'any[]',
          model: ''
        },
        ttamshiftdailies: {
          name: 'ttamshiftdailies',
          type: 'any',
          model: ''
        },
        ttadshiftbreaks: {
          name: 'ttadshiftbreaks',
          type: 'any[]',
          model: ''
        },
        ttamattstatuses: {
          name: 'ttamattstatuses',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttadattendance.ts